<template>
  <div class="grid grid-cols-4 gap-2">
    <div>
      <label class="" for="search">Cerca per nome</label>
      <input type="text" name="search" v-model="filter.search" />
    </div>

    <div class="">
      <label class="" for="operator">Mostra cancellati</label>
      <t-toggle v-model="filter.deleted" />
    </div>

    <div class="col-span-full">
      <div class="flex justify justify-end">
        <t-button native href="#" @click="fetchUsers" variant="neutral">
          <span
            >Aggiorna ricerca<i
              class="mx-2 fas fa-sync-alt fa-spin"
              v-show="loading"
            ></i>
          </span>
        </t-button>
      </div>
    </div>

    <div class="col-span-full mt-5">
      <div>
        <a-table
          v-bind:headers="['#', 'Nome completo', 'Username', 'Ruolo']"
          v-bind:data="fetch.users"
          v-bind:actions="['trash', 'edit']"
          @delete="deleteElement"
          @edit="navigate(route('users.edit', { user: $event.id }))"
        >
          <template v-slot:row="props">
            <td :class="props.tdClass">{{ props.rowIndex + 1 }}</td>
            <td :class="props.tdClass">{{ props.row.name }}</td>
            <td :class="props.tdClass">{{ props.row.username }}</td>
            <td :class="props.tdClass">{{ props.row.role.description }}</td>
          </template>
        </a-table>
      </div>
      <div class="flex justify justify-center mt-2">
        <div>
          <t-pagination
            :total-items="pagination.totalItems"
            :per-page="pagination.perPage"
            :limit="pagination.limit"
            v-model="pagination.currentPage"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      filter: {
        search: undefined,
        dateFrom: moment().subtract(1, "months").format("YYYY-MM-DD"),
        dateTo: moment().format("YYYY-MM-DD"),
        operator: undefined,
        deleted: false,
      },

      fetch: {
        operators: [],
        users: [],
      },

      pagination: {
        totalItems: 0,
        perPage: 20,
        limit: 5,
        currentPage: 1,
      },

      loading: false,
    };
  },

  computed: {},

  watch: {
    "pagination.currentPage"() {
      this.fetchUsers();
    },
  },

  methods: {
    async fetchUsers() {
      this.fetch.users = [];
      this.loading = true;

      try {
        var response = await axios.get(
          route("users.index", {
            page: this.pagination.currentPage,
            ...this.filter,
          })
        );

        if (response.status == 200) {
          let data = response.data.data;
          let meta = response.data.meta;

          this.fetch.users = data;

          this.pagination.totalItems = meta.total;
          this.pagination.currentPage = meta.current_page;
          this.pagination.perPage = meta.per_page;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    async deleteElement(user) {
      this.$awn.confirm(
        `Vuoi eliminare l'utente ${user.name}?`,
        async () => {
          var response = await axios.delete(
            route("users.destroy", {
              user: user.id,
            })
          );

          if (response && response.status == 200) {
            this.$awn.success(`Utente ${user.name} eliminato`);
          } else {
            this.$awn.alert("Si è verificato un errore");
          }

          this.fetchUsers();
        },
        () => {}
      );
    },
  },

  mounted() {
    this.fetchUsers();
  },
};
</script>
